<template>
<card
    class="col-8 col-sm-3 col-lg-3 border-0 mb-0"
    header-classes="p-1"
    body-classes="p-1"
    shadow
>
    <template #header>
        <div
            :class="`justify-content-${exercise.started ? 'between' : 'center'}`"
            class="d-flex align-items-center"
        >
            <div class="d-flex flex-column text-center">
                <span>
                    {{ exercise.started ? `${$t("exercise.time.remaining")}:` : $t("exercise.time.limit") }}
                </span>
            </div>
            <div v-if="exercise.started">
                <span class="time" :style="{ color: color.primary }">
                    {{ $moment("2015-01-01").startOf('day').seconds(exercise.student_time).format('HH:mm:ss') }}
                </span>
                <i :style="{ color: color.primary }" class="mdi mdi-24px mdi-timer-sand-full"/>
            </div>
        </div>
    </template>
    <div v-if="!exercise.started" class="d-flex row justify-content-center align-items-center">
        <base-button
            @click="startExercise"
            :style="$bgColor(color.primary)"
            class="mt-3"
        >
            {{$t('common.start')}}
        </base-button>
    </div>
</card>
</template>

<script>
import { mapGetters } from 'vuex';

import Card from '../../../../argon/components/Cards/Card';
import BaseButton from '../../../../argon/components/BaseButton';

export default {
    name: 'ClassExerciseTimer',
    components: {
        Card,
        BaseButton,
    },

    computed: mapGetters({
        exercise: 'CLASS_EXERCISE',
        color: 'COLOR',
    }),

    methods: {
        async spendStudentTime() {
            if (this.exercise.student_time > 0) {
                this.timeoutId = setTimeout(() => {
                    this.$store.commit('SET_CLASS_EXERCISE_STUDENT_TIME');
                    this.spendStudentTime();
                }, 1000);
            } else {
                this.submitAfterTimeout();
            }
        },
        async submitAfterTimeout() {
            if (!this.exercise || !this.exercise.id) return;
            await this.$store.dispatch('CLASS_EXERCISE_SUBMIT', { forced: true });
        },
        async startExercise() {
            await this.$store.dispatch('CLASS_EXERCISE_GET_STUDENT_TIME');
            if (this.exercise.started) this.spendStudentTime();
        },
    },

    beforeUnmount() {
        clearTimeout(this.timeoutId);
    },
};
</script>

<style lang="sass" scoped>
.time
    color: rgb(41, 41, 41)
    font-size: 1.25rem
    margin-bottom: 0
</style>
